import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lot-manual',
  templateUrl: './lot-manual.component.html',
  styleUrls: ['./lot-manual.component.sass']
})
export class LotManualComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
